import React from "react";

export const CustomActivitiesWrapper = ({ children } : any) => {
  return (
    <div className="flex flex-col max-h-[10rem] mb-2 md:mb-0 md:mr-2 w-80 flex-wrap">
      {children}
    </div>
  )
};
